export default {
  editor: {
    current_template: 'Template',
    toolbar_title: 'Template',
    use_button: 'Esporta HTML',
    save_button: 'Scarica HTML'
  },
  errors: {
    field: 'campo',
    generic_error: 'Qualcosa non ha funzionato',
    try_again: 'Riprova più tardi',
    error_code: 'Logref:',
    missing_source: 'Lo Userdb associato al template è stato rimosso. E\' necessario disassociarlo per poter eseguire l\'operazione richiesta.',
    '101906': 'La lunghezza del testo deve essere compresa tra 1 e 255 caratteri',
    '100000': 'Il customer è già presente',
    '100002': 'Customer non valido',
    '600000': 'Errore',
    '101802': 'Utente non autorizzato',
    '101803': 'Permessi insufficenti',
    '101904': 'Errore di validazione',
    '101905': 'Caratteri non alfanumerici non consentiti',
    '101907': 'TemplateModel deve essere del JSON valido',
    '101908': 'MergeTagSource id deve essere SEND',
    '101909': 'Il campo non può essere nullo',
    '101910': 'Il campo non può essere vuoto',
    '102000': 'Customer non trovato',
    '300100': 'Template non trovato',
    '300102': 'Template duplicato',
    '300103': 'Thumbnail non trovato',
    '3000104': 'Il Template non può avere una mergeTagsSource',
    '3000105': 'La proprietà Shared di un template non può essere nulla',
    '400100': 'Merge tag source non trovata',
    '4000102': 'Tipo di Merge Tags Source non valido',
    '400103': 'Merge tag source non trovata',
    '400104': 'Merge tag source mappata non trovata',
    '500100': 'Display condition non valida',
    '500102': 'Display condition duplicata',
    '500103': 'Display Condition non trovata',
    '500105': 'Hai raggiunto il numero massimo di Display Condition, non puoi crearne più di 50 sulla stessa Merge Tags Source.',
    '700100': 'Merge content non valido',
    '700101': 'L\'external source non esiste',
    '700102': 'La vista non esiste',
    '700103': 'Il campo dell\'external source non esiste o non è ricercabile',
    '700104': 'Nome del Merge Content duplicato',
    '800100': 'Nome categoria duplicato',
  },
  libraries: {
    MINE: 'I miei template',
    CUSTOM: 'Template personalizzati',
    PRESET: 'Template di default',
    SHARED: 'Template condivisi',
    empty_library_heading: 'Non c\'è niente qui, a parte me!',
    empty_library_first_line: 'Non hai ancora un template.',
    empty_library_second_line: 'Aggiungine uno da zero o scegline uno dai Default'
  },
  modals: {
    cancel_button: 'Annulla',
    continue_button: 'Continua',
    name_exists: 'Un altro template col nome {propName} esiste già',
    open_selected_template: 'Apri il template selezionato',
    overwrite_button: 'Sovrascrivi',
    save_button: 'Salva',
    save_into_library: 'Salva in',
    duplicate_button: 'Duplica',
    success_message: 'Azione eseguita con successo',
    share_custom_message: 'Il template è adesso condiviso con le eventuali sotto aziende. Se l\'azienda in esame non ha sotto aziende la condivisione non ha alcun effetto. Il template verrà automaticamente condiviso con eventuali sotto aziende all\'atto della loro creazione.',
    template_not_saved: 'Il template {propName} non è stato salvato.',
    unsaved_work: 'L\'apertura di un nuovo template comporterà la perdita delle modifiche effettuate',
    use_template: 'Attenzione usando il template senza averlo salvato potresti perdere le modifiche fatte',
    confirm_use: 'Continua',
    template_name: 'Nome del template',
    delete_template: 'Vuoi eliminare il template {propName} ?',
    duplicate_description: 'Il nuovo template sarà salvato in My Library con il nome:',
    close_button: 'Chiudi',
    share_button: 'Condividi',
    unshare_button: 'Smetti di condividere',
    share_template: 'Vuoi condividere il template {propName} ?',
    unshare_template: 'Vuoi smettere di condividere il template {propName} ?',
    invalid_template_for_library: 'Non è possibile salvare un template associato ad uno userDb nella libreria default/personalizzati',
    select_page: 'Scegli la pagina a cui vuoi andare',
    jump_page: 'Vai alla pagina',
    download: 'Il template {propName} potrebbe avere delle modifiche non salvate, verrà scaricata l\'ultima versione salvata',
    download_button: 'Scarica',
    row_category_exists: 'Un\'altra categoria col nome {propName} esiste già',
  },
  template: {
    use: 'Usa',
    rename: 'Rinomina',
    copy: 'Duplica',
    delete: 'Cancella',
    share: 'Condividi',
    unshare: 'Smetti di condividere',
    share_label: 'condiviso',
    download: 'Scarica'
  },
  toolbar: {
    back_to_work: 'Riprendi le modifiche a',
    current_template: 'Template',
    start_from_scratch: 'Comincia da capo',
    title: 'Template',
    search: 'Cerca',
    placeholder_search: 'Cerca per nome template'
  },
  filters: {
    date_locale: 'it-IT',
    button_label: 'Filter Conditions',
    add_filter: 'Aggiungi un nuovo filtro',
    empty_list: 'non sono presenti filter conditions',
    list_name: 'Nome filtro',
    list_created: 'Creato',
    list_actions: 'Azioni',
    must_satisfy: 'Il mio filtro deve soddisfare',
    all_conditions: 'Tutte le condizioni (E)',
    one_of_conditions: 'Almeno una di queste condizioni (O)',
    name: 'Nome',
    name_error: 'Il nome del filtro è obbligatorio',
    type_error: 'Il tipo del filtro è obbligatorio',
    field: 'Campo',
    operator: 'Operatore',
    value: 'Valore',
    back: 'Torna alla lista dei filtri',
    apply: 'Applica senza salvare',
    EQ: 'uguale a',
    NOT_EQ: 'diverso da',
    CONTAINS: 'contiene',
    NOT_CONTAINS: 'non contiene',
    GT: 'maggiore di',
    LT: 'minore di',
    EMPTY: 'vuoto',
    NOT_EMPTY: 'non vuoto',
    NULL: 'nullo',
    NOT_NULL: 'non nullo',
    duplicate_error: 'Esiste già un filtro con lo stesso nome',
    save: 'Salva',
    save_as_new: 'Salva come nuovo filtro',
    confirm_delete: 'Sei sicuro di voler cancellare la condizione {propName}',
    confirm_delete_yes: 'Sì',
    confirm_delete_no: 'No'
  },
  tags: {
    button_open_modal: 'Gestisci Tag',
    template_tags_limitation_msg: 'Puoi scegliere al massimo 3 tag',
    tags_limitation_msg: 'Ci devono essere al massimo 50 tag e ognuno di essi deve essere composto al massimo di 10 caratteri. Sono ammessi solo caratteri alfanumerici più il carattere meno (-) e underscore (_).',
    invalid_tag_msg: 'Ogni tag deve essere composto al massimo di 10 caratteri e sono ammessi solo caratteri alfanumerici più il carattere meno (-) e underscore (_).',
    placeholder_add_tag: 'Aggiungi un tag',
    search_by: 'Cerca per tags',
    select_label: 'Premi invio per selezionare',
    selected_label: 'Selezionato',
    deselect_label: 'Premi invio per rimuovere',
    max_message: 'Massimo di 3 tag selezionati. Rimuovere un tag selezionato per selezionarne un altro.',
    not_found_message: 'Nessun elemento trovato. Prova a cambiare la ricerca.',
    no_options: 'La lista è vuota',
    add_tags: 'Aggiungi tags',
    create_tag: 'Premi invio per creare un tag',
    invalid_tag: 'Il tag {propName} è invalido',
    delete_tags: 'Stai per cancellare uno o più tag, eventuali associazioni con i template verranno rimosse.'
  },
  content: {
    dynamic_contents: 'Contenuti dinamici',
    dynamic_contents_alert: 'Invia e-mail altamente mirate e personalizzate a ciascun destinatario: maggiori dettagli ',
    add_content_btn: 'Aggiungi contenuto dinamico',
    back_link: 'Torna alla lista dei contenuti dinamici',
    form_title: 'Dettagli contenuto dinamico',
    structure_title: 'DEFINISCI LA STRUTTURA',
    name: 'Nome contenuto dinamico',
    source: 'Sorgente esterna',
    view: 'Vista',
    rule: 'REGOLA',
    searchable_field: 'Campo della sorgente esterna',
    operation: 'Operatore',
    value: 'Valore',
    content: 'UserDB',
    field: 'Campo',
    static_field: 'Usa valore costante',
    dynamic_field: 'Usa campo UserDB',
    save: 'Salva',
    equal: 'Uguale a',
    content_name_error: 'Inserisci il nome del contenuto dinamico!',
    source_error: 'Seleziona una sorgente esterna!',
    view_error: 'Seleziona una vista!',
    field_error: 'Seleziona un campo!',
    value_error: 'Seleziona un valore!',
    userdb_error: 'Seleziona uno userDb!',
    userdb_field_error: 'Seleziona un campo dello userDb!',
    saved_content_title: 'Contenuto salvato',
    contents_error_title: 'Non è possibile recuperare i contenuti dinamici',
    contents_extra_info_error_title: 'Non è possibile recuperare delle informazioni extra',
    saved_content_message: 'Contenuto { name } salvato',
    userdb_error_title: 'Non è possibile recuperare gli userDb',
    userdb_fields_error_title: 'Non è possibile recuperare i campi dello userDb',
    sources_error_title: 'Non è possibile recuperare le sorgenti esterne',
    content_save_error: 'Non è possibile salvare il merge content',
    load_source_info_error: 'Non è stato possibile recuperare la sorgente esterna o i campi ricercabili',
    field_not_found: 'Campo ricercabile non trovato',
    view_not_found: 'Vista non trovata',
    source_not_found: 'Sorgente esterna non trovata',
    merge_tag_source_info_error: 'Non è stato possibile recuperare le informazioni del contenuto',
    delete_content_title: 'Cancella contenuto dinamico',
    delete_content: 'Vuoi cancellare {propName}?',
    delete_content_error: 'Non è stato possibile cancellare il contenuto dinamico',
    create_content_title: 'Crea un nuovo contenuto dinamico'
  },
  row_categories: {
    container_title: 'Gestisci categorie',
    empty_list: 'Non sono presenti categorie',
    back: 'Torna alla lista delle categorie',
    add_category: 'Aggiungi categoria',
    list_name: 'Categorie',
    list_actions: 'Azioni',
    name: 'Nome categoria',
    name_empty: 'Il nome della categoria è obbligatorio',
    save: 'Salva',
    save_as_new: 'Salva nuova categoria',
    confirm_delete: 'Sei sicuro di voler cancellare la categoria {propName}?',
    confirm_delete_warning: 'Attenzione: verranno cancellate tutte le righe appartenenti alla categoria.',
    confirm_delete_yes: 'Sì',
    confirm_delete_no: 'No',
    select_label: 'Premi invio per selezionare',
    selected_label: 'Selezionato',
    deselect_label: 'Premi invio per rimuovere',
    create_category_label: 'Premi invio per creare una categoria',
  },
  saved_rows: {
    container_title: 'Salva riga',
    container_title_edit: 'Modifica riga',
    container_subtitle: 'Salva questa riga nella tua libreria per usarla in futuro.',
    container_subtitle_edit: 'Aggiorna i dettagli della tua riga.',
    category: 'Categoria',
    name: 'Nome riga',
    name_empty: 'Il nome della riga è obbligatorio',
    save: 'Salva',
    category_empty: 'La categoria è obbligatoria',
    no_categories_found: 'Nessuna categoria trovata',
    only_one_category: 'Puoi selezionare solo una categoria',
    save_as_new: 'Salva come nuova',
    update: 'Aggiorna'
  },
  general: {
    name: 'Nome',
    version_date: 'Ultima Modifica',
    version_by: 'Utente',
    database: 'UserDB',
    delete: 'Cancella',
    edit: 'Modifica',
    here: 'qui'
  },
  test: {
    title: 'Invio di test',
    subject: 'Oggetto',
    sender: 'Mittente',
    mail_from: 'Indirizzo Mittente',
    reply_to: 'Rispondi a',
    recipient: 'Destinatario',
    duplicate_recipient_error: 'Il destinatario è già presente',
    max_recipient_error: 'Non è possibile aggiungere altri destinatari.',
    duplicate_merge_tag_error: 'Il merge tag è già presente.',
    empty_subject_error: 'Il campo oggetto è obbligatorio.',
    empty_sender_error: 'Il campo mittente è obbligatorio.',
    empty_mail_from_error: 'Il campo indirizzo mittente è obbligatorio.',
    empty_reply_to_error: 'Il campo rispondi a è obbligatorio.',
    empty_recipients_error: 'È necessario inserire almeno un destinatario.',
    missing_immediate_error: 'È necessario configurare una delivery immediate con alias',
    missing_immediate_alias: '"Email-Designer-Test-Delivery".',
    missing_immediate_link_name: 'Clicca qui',
    missing_immediate_link: 'https://docs.contactlab.com/it/docs/guides/send/create/email-delivery/immediate-message',
    missing_immediate_error_after: 'per saperne di più.',
    missing_template_errror: 'Attenzione: stai editando un nuovo template, per richiedere un invio di test devi prima salvarlo.',
    test_sent: 'Messaggio di test {propName} inviato.',
    invalid_email_address: 'Indirizzo email non valido.',
    send: 'Invia'
  },
  validation_errors: {
    '101417': 'Il campo destinatario è obbligatorio.',
    '101418': 'Hai raggiunto il limite massimo di destinatari.',
    '101419': 'Hai raggiunto il limite massimo di allegati.',
    '101427': 'Il tipo di allegato specificato non è valido.',
    '101428': 'Indirizzo email del destinatario non valido.',
    '101429': 'Indirizzo email in CC non valido.',
    '101430': 'Indirizzo email in BCC non valido',
    '101431': 'Il contenuto del messaggio non può essere vuoto.',
    '101432': 'Il campo oggetto è obbligatorio.',
    '101433': 'Il campo indirizzo mittente è obbligatorio.',
    '101434': 'Il campo mittente è obbligatorio.',
    '101435': 'Il campo \'rispondi a\' è obbligatorio',
    '101436': 'Indirizzo email del mittente non valido.',
    '101437': 'Il nome dell\'allegato è obbligatorio.',
    '101438': 'Il tipo di allegato è obbligatorio.',
    '101439': 'L\'allegato non può essere vuoto.',
    '101441': 'La dimensione complessiva degli allegati eccede il limite.',
    '101444': 'Indirizzo email \'rispondi a\' non valido.'
  }
};
